import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Slider from "react-slick";

/* Result */
import Result from 'iotera-base/result'

/* Redux */
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux';

/* React Router */
import { withRouter } from 'react-router-dom'

/* Sagas Action */
import { buildWBoundActions } from '../../redux/ducks'
import { actions as notificationActions } from '../../redux/ducks/notification'

/* Routes */
import { domain, isTenant, RedirectToApp, S } from '../../routes/routes'

/* Credentials Token */
import { tenantToken, setToken } from '../../auth/token';

/* Object Json */
import { isEmpty } from 'iotera-base/object';
import { safeDeepGet, safeDeepGetWithType } from 'iotera-base/json';

/* Logo */
import { titleCaseRemoveUS } from '../../lib/components/formatter';
import IoteraClass from '../../lib/components/react/react-class';

import { BASE_STATIC_URL } from '../../webservice/redux';

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

/* Webservice Redux */
const LOGIN = "LOGIN";
const WKEY = 'APP_LOGIN';
const wBoundActions = buildWBoundActions(WKEY);

const styles = theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  margin: {
    margin: theme.spacing.unit,
  },
  textField: {
    flexBasis: 200,
  }

});

class TenantLogin extends IoteraClass {
  constructor(props) {
    super(props);
    let widthForm;
    if (window.innerWidth > 576) {
      if (window.innerWidth >= 768) {
        if (window.innerWidth >= 1200) {
          widthForm = '36%';
        } else {
          widthForm = '52%';
        }
      } else {
        widthForm = '64%';
      }
    } else {
      widthForm = '80%';
    }
    this.state = {
      username: '',
      password: '',
      appname: '',
      submitted: false,
      showPassword: false,
      loginSuccess: false,
      loading: false,
      widthForm
    };

    this.resize = this.resize.bind(this);
    this.handleRegis = this.handleRegis.bind(this)
  }

  handleRegis() {
    this.props.history.push('.' + S + 'registration')
  };

  resize(event) {
    let widthForm;
    if (window.innerWidth > 576) {
      if (window.innerWidth >= 768) {
        if (window.innerWidth >= 1200) {
          widthForm = '36%';
        } else {
          widthForm = '52%';
        }
      } else {
        widthForm = '64%';
      }
    } else {
      widthForm = '80%';
    }
    this.setState({
      widthForm
    })
  }

  componentDidMount() {
    const _this = this;
    const _props = _this.props
    const _state = _this.state
    const _domain = domain(_props);
    const _isTenant = isTenant(_props);
    _props.wSetConfig({
      single_config: {
        [LOGIN]: {
          wparam: {
            domain: _domain,
            usingAuth: false,
            method: "POST",
            path: "/service/web/tenant/account/auth/login"
          },
          wcallback: {
            finished: function (id, result) {
              if (result.code === Result.HTTP.OK) {
                const responseResult = safeDeepGetWithType(result, ['body', 'response_result'], Result.UNKNOWN_ERROR);
                if (responseResult === Result.SUCCESS) {
                  const tokenId = safeDeepGet(result, ['body', 'id']);
                  const token = safeDeepGet(result, ['body', 'token']);
                  setToken(_domain, _isTenant, tokenId, token);
                  _props.showSingleNotification({
                    message: 'Selamat datang ' + titleCaseRemoveUS(_state.username),
                    position: 'tr', level: 'info'
                  });
                  _this.setState({ loginSuccess: true, loading: false });
                  return;
                }
              } else if (result.code === Result.HTTP.BAD_REQUEST) {
                const responseResult = safeDeepGetWithType(result, ['body', 'response_result'], Result.UNKNOWN_ERROR);
                if (responseResult === -1) {
                  _props.showSingleNotification({ message: 'Username tidak terdaftar', position: 'tl', level: 'error' });
                } else if (responseResult === -2) {
                  _props.showSingleNotification({ message: 'Username dan password tidak sesuai', position: 'tl', level: 'error' });
                } else {
                  _props.showSingleNotification({ message: 'Login gagal', position: 'tl', level: 'error' });
                }
              } else if (result.code === Result.NETWORK_FAILURE) {
                _props.showSingleNotification({
                  message: 'Tidak ada koneksi, cek kembali jaringan internet',
                  position: 'tl', level: 'error'
                });
              } else if (result.code === Result.HTTP.INTERNAL_SERVER_ERROR) {
                _props.showSingleNotification({
                  message: 'Server sedang down, silahkan coba lain waktu',
                  position: 'tl', level: 'error'
                });
              } else {
                _props.showSingleNotification({ message: 'Login gagal', position: 'tl', level: 'error' });
              }
              _this.setState({ submitted: false, loading: false });
            }
          },
          wreducer: {
            enable: false
          }
        }
      }
    });
  }

  componentWillUnmount() {
    const _props = this.props
    _props.wUnsetConfig({ single_config: WKEY });
  }

  handleSubmit = event => {
    const _this = this
    const _props = _this.props
    const _state = _this.state
    event.preventDefault();
    this.props.wSingleRequestCall({
      id: LOGIN,
      body: {
        input: _state.username,
        pass: _state.password
      }
    });
    _this.setState({ submitted: true, loading: true });
  }

  toUserLogin = event => {
    event.preventDefault();
    const _this = this
    const _state = _this.state
    window.open(`/${_state.appname}/login`);
    _this.setState({ appname: '' })
  }

  onSelectCarousel = (index) => {
    this.setState({ selectedCarousel: index });
  }

  onSelectTab = (index) => {
    this.setState({ selectedTab: index });
  }

  handleClickShowPassword = () => {
    this.setState(state => ({ showPassword: !state.showPassword }));
  };

  handleChange = prop => event => {
    this.setState({ [prop]: event.target.value });
  };

  render() {
    const _this = this
    const _props = _this.props
    const _state = _this.state
    window.onresize = _this.resize;
    // Redirect to App
    const token = tenantToken();
    if (!isEmpty(token) || _state.loginSuccess) {
      return (
        <RedirectToApp {..._props} />
      );
    }
    const selectedCarousel = safeDeepGetWithType(_state, ['selectedCarousel'], 0);
    const carouselClassname = { 0: '', 1: '', 2: '' }
    carouselClassname[selectedCarousel] = 'active'
    const selectedTab = safeDeepGetWithType(_state, ['selectedTab'], 0);
    const tabClassname = { 0: 'false', 1: 'false' }
    const tabActiveClassname = { 0: '', 1: '' }
    tabClassname[selectedTab] = 'true'
    tabActiveClassname[selectedTab] = 'show active'
    const backgroundUrl = `${BASE_STATIC_URL}login/ills-overview.svg`
    const DashboardImage = `${BASE_STATIC_URL}login/ic-dashboard.svg`
    const DeviceImage = `${BASE_STATIC_URL}login/ic-device.svg`
    const CloudImage = `${BASE_STATIC_URL}login/ic-cloud.svg`
    const LogoImage = `${BASE_STATIC_URL}logo/logo.svg`
    var settings = {
      dots: true,
      speed: 2000,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      autoplay: true,
      autoplaySpeed: 5000,
      useCSS: true,
      waitForAnimate: true,
      vertical: true,
      adaptiveHeight: true,
      pauseOnFocus: true,
      dotsClass: 'slick-dots-iotera',
      appendDots: dots => (
        <div>
          <ul style={{ marginBottom: 5 }}> {dots} </ul>
        </div>
      )
    };
    return (
      <div className="io-container-fluid">
        <div className="io-row">
          <div className="io-col-12 io-col-xl-4 login-wrapper">
            <div className="brand">
              <img src={LogoImage} alt="logo" />
            </div>
            <h2 className="font-weight-normal">Login to <strong>Iotera</strong></h2>
            <p className="text-gray-300">
              Manage your electricity management smartly
            </p>
            <ul className="io-nav nav nav-tabs" id="myTab" role="tablist">
              <li className="nav-item" onClick={() => _this.onSelectTab(0)} style={{ cursor: 'pointer' }}>
                <div className={`nav-link ${tabActiveClassname[0]}`} id="tab-1-tab" data-toggle="tab" role="tab"
                  aria-controls="tab-1" aria-selected={tabClassname[0]}>As Tenant</div>
              </li>
              <li className="nav-item" onClick={() => _this.onSelectTab(1)} style={{ cursor: 'pointer' }}>
                <div className={`nav-link ${tabActiveClassname[1]}`} id="tab-2-tab" data-toggle="tab" role="tab"
                  aria-controls="tab-2" aria-selected={tabClassname[1]}>As User</div>
              </li>
            </ul>
            <div className="tab-content">
              <div className={`tab-pane fade ${tabActiveClassname[0]}`} id="tab-1" role="tabpanel" aria-labelledby="tab-1">
                <form className="io-form mt-10" method="GET" id="login"
                  style={{ backgroundColor: 'transparent', boxShadow: '0 0 0px rgba(0,0,0,0)', padding: 0 }}>
                  <div className="io-form-group">
                    <input type="text" className="io-form-control" id="username" aria-describedby="usernameHelp"
                      placeholder="Username" onChange={_this.handleChange('username')} value={_state.username} />
                    <label htmlFor="username">Username</label>
                    <div className="alert alert__right alert-danger" role="alert" style={{ width: '262px', display: 'none' }}>
                      <div className="row no-gutters align-items-center">
                        <div className="col-auto" style={{ width: '32px' }}>
                          <div className="embed-responsive embed-responsive-1by1" s="">
                            <div className="embed-responsive-item">
                              <i className="material-icons">error_outline</i>
                            </div>
                          </div>
                        </div>
                        <div className="col pl-3">
                          <p className="small mb-0">You entered an incorrect email, password, or both.</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="io-form-group mt-8">
                    <input type={_state.showPassword ? "text" : "password"} className="io-form-control" id="password"
                      aria-describedby="passwordHelp" placeholder="Password" onChange={_this.handleChange('password')}
                      value={_state.password} />
                    <label htmlFor="password">Password</label>
                    <div className="icon icon__right"
                      onClick={_this.handleClickShowPassword}
                    >
                      {
                        _state.showPassword ?
                          <i className="material-icons" style={{ maxWidth: 20 }}>visibility_on</i>
                          :
                          <i className="material-icons">visibility_off</i>
                      }
                    </div>
                  </div>
                  <div className="io-row mt-8">
                    <div className="io-col">
                    </div>
                    <div className="io-col-auto">
                      {/* <div onClick={() => _props.showSingleNotification({
                        message: 'Maaf, fitur belum tersedia',
                        position: 'tl', level: 'info'
                      })} className="text-gray-400" style={{ cursor: 'pointer' }}>Forgot Password?</div> */}
                    </div>
                  </div>
                  <div className="io-row mt-8">
                    {/* Disable register tenant from UI for some time */}
                    {/* <div className="io-col-12 io-col-lg-6">
                      <a href="/admin/registration" className="io-btn btn-block btn-ghost-primary">Register</a>
                    </div>
                    <div className="io-col-12 io-col-lg-6 order-first order-lg-last mb-4 mb-lg-0">
                      <button type="submit" onClick={_this.handleSubmit} className="io-btn btn-block io-btn-primary"
                        style={{ minWidth: '100%' }}>Login</button>
                    </div> */}
                    <div className="io-col-12 io-col-lg-12 order-first order-lg-last mb-4 mb-lg-0">
                      <button type="submit" onClick={_this.handleSubmit} className="io-btn btn-block io-btn-primary"
                        style={{ minWidth: '100%' }}>Login</button>
                    </div>
                  </div>
                </form>
              </div>
              <div className={`tab-pane fade ${tabActiveClassname[1]}`} id="tab-2" role="tabpanel" aria-labelledby="tab-2">
                <form className="io-form mt-10" method="GET"
                  style={{ backgroundColor: 'transparent', boxShadow: '0 0 0px rgba(0,0,0,0)', padding: 0 }}>
                  <p className="font-weight-normal text-gray-300">
                    Enter your <strong className="text-gray-500">Application Name</strong>
                  </p>
                  <div className="io-form-group">
                    <input type="text" className="io-form-control" id="name" aria-describedby="nameHelp"
                      placeholder="Application Name" onChange={_this.handleChange('appname')} value={_state.appname} />
                    <label htmlFor="name">Application Name</label>
                  </div>
                  <div className="io-row mt-8">
                    <div className="io-col-6">
                      <button type="submit" onClick={_this.toUserLogin} className="io-btn btn-block io-btn-primary">Continue</button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div className="io-col-lg-8 d-none d-xl-block bg-image__cover"
            style={{
              backgroundImage: `url(${backgroundUrl})`,
            }}>
            <div className="io-row align-items-end h-100">
              <div className="io-col carousels carousels-fade-bottom slide px-12" style={{ marginBottom: 25 }}>
                <Slider ref={slider => (_this.slider = slider)} {...settings} >
                  <div className="card card__shadow-lg">
                    <div className="row no-gutters">
                      <div className="col-auto" style={{ width: '150px', backgroundColor: '#E9EFF5' }}>
                        <img src={DashboardImage} className="card-img p-8" alt="ic-device" />
                      </div>
                      <div className="col">
                        <div className="card-body d-flex align-items-center h-100">
                          <div>
                            <h4 className="card-title">Cuztomizable Analytic Dashboard</h4>
                            <p className="card-text text-gray-300">
                              Analytics engine sesuai kebutuhan Anda, dan API untuk integrasi ke ekosistem IT Anda.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card card__shadow-lg">
                    <div className="row no-gutters">
                      <div className="col-auto" style={{ width: '150px', backgroundColor: '#E9EFF5' }}>
                        <img src={DeviceImage} className="card-img p-8" alt="ic-device" />
                      </div>
                      <div className="col">
                        <div className="card-body d-flex align-items-center h-100">
                          <div>
                            <h4 className="card-title">Device Integration</h4>
                            <p className="card-text text-gray-300">
                              Gateway and end-device connected to middleware with the concept of any-to-any. In other words,
                              we can integrate various assets.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card card__shadow-lg">
                    <div className="row no-gutters">
                      <div className="col-auto" style={{ width: '150px', backgroundColor: '#E9EFF5' }}>
                        <img src={CloudImage} className="card-img p-8" alt="ic-device" />
                      </div>
                      <div className="col">
                        <div className="card-body d-flex align-items-center h-100">
                          <div>
                            <h4 className="card-title">Cloud System</h4>
                            <p className="card-text text-gray-300">The three components above run on Iotera middleware.
                            This entire system can be deployed on Iotera cloud (subscribed)
                          </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Slider>
              </div>
            </div >
          </div >
        </div >
      </div >
    )
  }
}

const mapDispatchToProps = function (dispatch) {
  return {
    ...wBoundActions(dispatch),
    ...bindActionCreators(notificationActions, dispatch),
  }
};

TenantLogin.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default connect(null, mapDispatchToProps)(withRouter(withStyles(styles)(TenantLogin)));
